import { keyframes, styled } from 'styled-components'
import { themeMedia } from '../../../styles/theme'
import { brandConfig } from '../../../config/brandConfig'
import { IN_GAME_BOTTOM_NAVIGATION_HEIGHT } from '../../../utils/constants'

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 1;
    transform: translateY(-2px) scale(1.1);
  }
`

export const StyledBottomBar = styled.div`
  ${themeMedia.maxMobile`
    position: fixed;
    box-sizing: border-box;
    width: 100%;
    z-index: 9999;
    height: ${IN_GAME_BOTTOM_NAVIGATION_HEIGHT}px;
    bottom: -1px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #000;
    padding: 0 16px;

    a {
      text-decoration: none;
      height: 100%;
      flex: 0 0 auto;
    }
  `}
  display: none;
`

export const StyledBottomNavButton = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 56px;
  background-color: #000;
`

export const StyledBottomNavButtonIcon = styled.img`
  height: 30px;
`

export const StyledBottomNavButtonLabel = styled.p`
  position: relative;
  margin: 0;
  color: ${({ amount }) => {
    const isZeroOrUndefined =
      typeof amount === 'undefined' || Number(amount) === 0
    return isZeroOrUndefined
      ? brandConfig.colors.white.main
      : brandConfig.colors.accentColors.secondary.main
  }};
  font-size: 9px;
  line-height: 1;
  text-align: center;
  margin-bottom: 8px;
  word-break: break-word;
  font-weight: 700;

  &::after {
    content: '';
    display: ${({ isIncreasing }) => (isIncreasing ? 'inline-block' : 'none')};
    width: 0;
    height: 0;
    border-left: 2.5px solid transparent;
    border-right: 2.5px solid transparent;
    border-bottom: 4.5px solid #00dd70;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -6px;
    animation: ${({ isIncreasing }) => (isIncreasing ? fadeSlideIn : 'none')}
      0.3s ease forwards;
  }
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 24px;
  gap: 10px;

  p {
    line-height: 145%;
    margin-bottom: 20px;
    color: ${brandConfig.colors.darkGreys[2].main};
  }
`
